export const PO_BASE_URL = "/material-po";

const PO_ROUTE_URLS = {
    HOME: `${PO_BASE_URL}/dashboard`,
    LOGIN: `${PO_BASE_URL}/login`,
    MTO: `${PO_BASE_URL}/mto-management`,
    PR: `${PO_BASE_URL}/pr-management`,
    INQUIRY: `${PO_BASE_URL}/inquiry-management`,
    OFF_COM: `${PO_BASE_URL}/offer-comparision-management`,
    CONTER_OFF: `${PO_BASE_URL}/counter-offer-management`,
    ORDER_PLACE: `${PO_BASE_URL}/order-management`,
}

export default PO_ROUTE_URLS;